const TimerOverlay = () => {
  return (
    <div className="flex grow items-center absolute top-0 right-0 h-full w-1/2 bg-cream opacity-95 text-m">
      <p className="mx-auto">Please refresh again after 15 seconds!</p>
    </div>
  );
};

export default TimerOverlay;
